import './resizeSensor';
import StickySidebar from 'sticky-sidebar';

export default function sidebar() {
    const sidebar = new StickySidebar('.js-sidebar', {
        containerSelector: '.page-layout',
        innerWrapperSelector: '.js-sidebar-inner',
        topSpacing: 0,
        bottomSpacing: 0,
        resizeSensor: true,
        minWidth: 1161
    });

    const sidebarLayers = Array.from(document.querySelectorAll('.page-layout-sidebar-layer'));

    const openSidebarFormBtns = Array.from(document.querySelectorAll('.js-open-callback-form'));
    const closeSidebarFormBtns = Array.from(document.querySelectorAll('.js-close-callback-form'));


    openSidebarFormBtns.forEach(btn => {
        btn.addEventListener('click', event => {
            event.preventDefault();
    
            sidebarLayers.forEach(layer => layer.classList.remove('active'));
    
            if (sidebarLayers[1]) {
                sidebarLayers[1].classList.add('active');
                sidebar.updateSticky();
            }
        });
    })
    

    closeSidebarFormBtns.forEach(btn => {
        btn.addEventListener('click', event => {
            event.preventDefault();
            sidebarLayers.forEach(layer => layer.classList.remove('active'));
            if (sidebarLayers[0]) {
                sidebarLayers[0].classList.add('active');
                sidebar.updateSticky();
            }
        });
    });
}
